import React, { useState, useEffect } from "react";
import { classNames } from "primereact/utils";
import { Dropdown } from "primereact/dropdown";
import {
  managerService,
  permissionService,
  userService,
} from "../../../../services/extensions";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { toast } from "react-toastify";
import { ErrorMessage, useFormik } from "formik";
import properties from "../../../../config/environmentProperties";

export const UserManager = () => {
  const [managerList, setManagerList] = useState([]);
  const [selectedManager, setSelectedManager] = useState(null);
  const [selectedCurrentManager, setSelectedCurrentManager] = useState(null);
  const [assignUserList, setAssignUserList] = useState([]);
  const [selectedAssignUserList, setSelectedAssignUserList] = useState([]);
  const [user, setUser] = useState([]);
  const [filterUserList, setFilterUserList] = useState([]);
  const [selectedFilterUserList, setSelectedFilterUserList] = useState([]);
  const [showMessage, setShowMessage] = useState(false);
  const [designation, setDesignation] = useState([]);

  const imgPath = properties.currentEnvironment.docPath + "images/";

  const formik = useFormik({
    initialValues: {
      currentReportingManager: null,
      firstName: null,
      lastName: null,
      designation: null,
      ecn: null,
      email: null,
    },
    validate: (data) => {
      let errors = {};

      if (!data.currentReportingManager) {
        errors.currentReportingManager = "Reporting manager is required.";
      }
      if (!data.firstName) {
        errors.firstName = "First Name is required.";
      }
      if (!data.lastName) {
        errors.lastName = "Last Name is required.";
      }
      if (!data.designation) {
        errors.designation = "Designation is required.";
      }
      if (!data.email) {
        errors.email = "Email is required.";
      } else if (
        !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(data.email)
      ) {
        errors.email = "Invalid email address. E.g. example@email.com";
      }
      return errors;
    },
    onSubmit: (data) => {
      setShowMessage(true);
      // formik.resetForm();
      addUser(data);
    },
  });

  const isFormFieldValid = (name) =>
    !!(formik.touched[name] && formik.errors[name]);
  const getFormErrorMessage = (name) => {
    return (
      isFormFieldValid(name) && (
        <small className="p-error">{formik.errors[name]}</small>
      )
    );
  };

  useEffect(() => {
    getManagers("MANAGER");
    getAssignedUserDetails();
    getDesignations();
  }, []);

  const getDesignations = (param = {}) => {
    userService.getDesignations().then((resp) => {
      setDesignation(resp.data.data);
    });
  };

  const assignUser = () => {
    let userListIds = selectedFilterUserList.map((a) => a.id);
    let param = {
      userIds: userListIds,
      // superiorId: selectedCurrentManager.id,
      superiorId: selectedManager.id,
    };
    try {
      managerService.addUsers(param).then((resp) => {
        if (param.userIds.length === 0) toast.error("Please select one user");
        else if (resp.data.success) {
          toast.success("User successfully added");
          getAssignedUserDetails(selectedManager.id);
          getUser();
          setSelectedFilterUserList([]);
        }
      });
    } catch (error) {
      console.log("Catch Error :", error);
    }
  };

  const unassignUser = () => {
    let userListIds = selectedAssignUserList.map((a) => a.id);
    let param = {
      userIds: userListIds,
      superiorId: selectedManager.id,
    };
    try {
      managerService.removeUsers(param).then((resp) => {
        if (resp.data.success) {
          toast.success("User successfully removed");
          getAssignedUserDetails(selectedManager.id);
          getUser();
          setSelectedAssignUserList([]);
        }
      });
    } catch (error) {
      console.log("Catch Error :", error);
    }
  };

  const getManagers = (param = {}) => {
    managerService.getAllUserByRole(param).then((resp) => {
      // setManagerList(resp.data.data);
      try {
        resp.data.data.map(
          (user, index) =>
          (managerList[index] = {
            id: user.id,
            name:
              user.firstName.charAt(0).toUpperCase() +
              user.firstName.slice(1) +
              " " +
              user.lastName.charAt(0).toUpperCase() +
              user.lastName.slice(1),
          })
        );
      } catch (error) { }
    });
  };

  const getManagerData = (e) => {
    setSelectedManager(e.value);
    getAssignedUserDetails(e.value.id);
  };

  const getAssignedUserDetails = (param = {}) => {
    managerService.getAssignedUserByManager(param).then((resp) => {
      setAssignUserList(resp.data.data);
    });
  };

  const resetData = () => {
    setSelectedCurrentManager("");
    setState({
      ecn: "",
      firstName: "",
      lastName: "",
      email: "",
    });
    formik.setFieldValue("designation", "");
  };

  const [state, setState] = useState({
    currentReportingManager: null,
    ecn: null,
    firstName: null,
    lastName: null,
    email: null,
  });

  const handleChange = (e) => {
    let obj = {
      ...state,
      [e.target.name]: e.target.value,
    };
    setState(obj);
  };

  const searchUser = (param = {}) => {
    if (state.ecn) {
      param = {
        ecn: state.ecn,
      };
    } else if (state.email) {
      param = {
        email: state.email,
      };
    } else if (state.firstName) {
      param = {
        firstName: state.firstName,
      };
    } else if (state.lastName) {
      param = {
        lastName: state.lastName,
      };
    } else if (selectedCurrentManager && selectedCurrentManager.id) {
      param = {
        superiorId: selectedCurrentManager.id,
      };
    } else if (formik.values.designation) {
      param = {
        designationId: formik.values.designation,
      };
    }
    try {
      managerService.searchUsers(param).then(
        (resp) => {
          if (resp.status === 200) {
            setFilterUserList(resp.data.data);
          }
        },
        (error) => {
          setAssignUserList();
        }
      );
    } catch (error) { }
  };



  const getUser = () => {
    managerService.getAllUserByRole("MANAGER").then((resp) => {
      setUser(resp.data.data);
    });
  };
  const addUser = (data) => {
    try {
      managerService.addUsers(data).then((resp) => {
        if (resp.data.success) {
          toast.success("User successfully added");
          getUser();
        }
      });
    } catch (error) {
      console.log("Catch Error :", error);
    }
  };

  const EmpName = (rowData, options) => {
    const name = rowData.firstName + " " + rowData.lastName;
    return name;
  };

  const designationTemplate = (item) => {
    return item?.Designation?.title;
  };

  const buTemplate = (item) => {
    return item?.BusinessUnit?.title;
  };

  const imageBodyTemplate = (item) => {
    return (
      <div className="flex align-items-center gap-2">
        {item?.photo === "" || item?.photo === null ? (
          <span
            className="photo-span"
            style={{
              height: "35px", width: "35px", borderRadius: "50%", border: "2px solid #d7e9ff", display: "flex", alignItems: 'center', justifyContent: 'center', fontSize: "18px", fontWeight: "600", color: "#1369b6", padding: '5px', paddingTop: '1px'
            }}
          >
            {item.firstName.toUpperCase().substr(0, 1)}
            {item.lastName.toUpperCase().substr(0, 1)}
          </span>
        ) : (
          <img
            style={{
              height: "40px",
              width: "40px",
              borderRadius: "50%",
              border: "3px solid #d7e9ff",
              Top: "16px",
              bottom: "16px",
              left: "16px",
            }}
            src={imgPath + item?.photo || ""}
            alt=""
          />
        )}
        <div>{item.firstName + " " + item.lastName}</div>
      </div>
    );
  };

  return (
    <div className="p-3">
      <div className="grid">
        <div className="col-12">
          <div className="card-container p-3">
            <h1>User Manager</h1>
            <div className="p-fluid">
              <label>Manager</label>{" "}
              <div className="grid" style={{ marginTop: "10px" }}>
                <span className="p-float-label">
                  <Dropdown
                    style={{ width: "180%" }}
                    filter
                    id="manager"
                    name="manager"
                    value={selectedManager}
                    optionLabel="name"
                    options={managerList}
                    placeholder="Select a Manager"
                    onChange={(e) => getManagerData(e)}
                    appendTo="self"
                  />
                </span>

                <hr />

                <div className="grid p-fluid">
                  <div className="col-12">
                    <div className="mb-3 mt-3">
                      <Button
                        icon="pi pi-trash"
                        label="Remove"
                        className="p-button p-button-rounded"
                        style={{ width: "55%", marginLeft: "-7px" }}
                        onClick={unassignUser}
                        disabled={selectedAssignUserList.length === 0}
                      />
                      <Button
                        icon="pi pi-plus"
                        label="Add"
                        className="p-button p-button-rounded"
                        style={{ width: "45%", marginLeft: "3px" }}
                        onClick={assignUser}
                        disabled={selectedFilterUserList.length === 0}
                      />
                    </div>
                  </div>
                </div>

                {/* <div >
                  
                    
                      <Button
                        className="pt-2 p-button-rounded"
                        label="Remove"
                        onClick={unassignUser}
                      />
                    
                    
                      <Button
                        className="pt-2 p-button-rounded"
                        label="Add"
                        onClick={assignUser}
                      />
                    
                  
                </div> */}
              </div>
              <h1>Assigned Users Under Manager</h1>
              <DataTable
                value={assignUserList}
                selection={selectedAssignUserList}
                onSelectionChange={(e) => setSelectedAssignUserList(e.value)}
                paginator
                responsiveLayout="scroll"
                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                rows={10}
                rowsPerPageOptions={[10, 20, 50]}
              >
                <Column
                  selectionMode="multiple"
                  headerStyle={{ width: "50px" }}
                ></Column>
                <Column
                  field="ecn"
                  header="ECN"
                  sortable
                ></Column>
                <Column
                  field="firstName"
                  header="Name"
                  body={imageBodyTemplate}
                  sortable
                ></Column>
                <Column
                  field="email"
                  header="Email"
                  sortable
                ></Column>
                <Column
                  field=""
                  header="BU"
                  body={buTemplate}
                  sortable
                ></Column>
                {/* <Column field="project" header="Project(s)" sortable></Column>
                <Column field="shift" header="Shift" sortable></Column> */}
              </DataTable>
            </div>
            {/* <div className="mt-3">
              <Button
                className="pt-2 p-button-rounded"
                label="Remove"
                onClick={unassignUser}
              />
            </div> */}
          </div>
        </div>
        <div className="col-12">
          <div className="card-container p-3">
            <h1>Search Available Users</h1>
            <div className="grid p-fluid">
              <div className="col field">
                <label>First Name</label>
                <span className="p-float-label">
                  <InputText
                    id="firstName"
                    name="firstName"
                    value={state.firstName}
                    onChange={handleChange}
                    placeholder="Enter first name"
                  />
                </span>
              </div>
              <div className="col field">
                <label>Last Name</label>
                <span className="p-float-label">
                  <InputText
                    id="lastName"
                    name="lastName"
                    value={state.lastName}
                    onChange={handleChange}
                    placeholder="Enter last name"
                  />
                </span>
              </div>
            </div>

            <div className="grid p-fluid">
              <div className="col field">
                <label>ECN</label>
                <span className="p-float-label">
                  <InputText
                    id="ecn"
                    name="ecn"
                    value={state.ecn}
                    onChange={handleChange}
                    placeholder="Enter ECN"
                  />
                </span>
              </div>
              <div className="col field">
                <label>Email ID</label>
                <span className="p-float-label">
                  <InputText
                    id="email"
                    name="email"
                    value={state.email}
                    onChange={handleChange}
                    placeholder="Enter your email id"
                  />
                </span>
              </div>
            </div>

            <div className="grid p-fluid">
              <div className="col field">
                <label>Designation</label>
                <span className="p-float-label">
                  <Dropdown
                    filter
                    id="designation"
                    name="designation"
                    value={formik.values.designation}
                    placeholder="Select designation"
                    options={designation}
                    optionLabel="title"
                    optionValue="id"
                    onChange={formik.handleChange}
                  />
                </span>
              </div>
              <div className="col field">
                <label>Reporting Manager</label>
                <span className="p-float-label">
                  <Dropdown
                    filter
                    id="currentReportingManager"
                    name="currentReportingManager"
                    value={selectedCurrentManager}
                    optionLabel="name"
                    options={managerList}
                    placeholder="Select reporting manager"
                    onChange={(e) => setSelectedCurrentManager(e.value)}
                  />
                </span>
              </div>
            </div>

            <div className="grid p-fluid">
              <div className="col">
                <div className="mb-3 mt-3">
                  <Button
                    icon="pi pi-search"
                    label="Search"
                    className="p-button p-button-rounded mr-10"
                    style={{ width: "30%" }}
                    onClick={() => searchUser()}
                  />
                  <Button
                    icon="pi pi-times"
                    label="Reset"
                    className="p-button p-button-rounded"
                    style={{ width: "30%", marginLeft: "5px" }}
                    onClick={() => resetData()}
                  />
                </div>
              </div>
            </div>
            <div className="grid">
              <div className="col-12">
                <DataTable
                  value={filterUserList}
                  selection={selectedFilterUserList}
                  onSelectionChange={(e) => setSelectedFilterUserList(e.value)}
                  paginator
                  responsiveLayout="scroll"
                  paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                  currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                  rows={10}
                  rowsPerPageOptions={[10, 20, 50]}
                >
                  <Column
                    selectionMode="multiple"
                    headerStyle={{ width: "50px" }}
                  ></Column>
                  <Column
                    field="ecn"
                    header="ECN"
                    sortable
                  ></Column>
                  <Column
                    field="firstName"
                    header="Name"
                    body={imageBodyTemplate}
                    sortable
                  ></Column>
                  <Column
                    field="email"
                    header="Email"
                    sortable
                  ></Column>
                  <Column
                    field=""
                    header="Designation"
                    body={designationTemplate}
                    sortable
                  ></Column>
                  <Column
                    field=""
                    header="BU"
                    body={buTemplate}
                    sortable
                  ></Column>
                  {/* <Column field="project" header="Project(s)" sortable></Column>
                  <Column field="shift" header="Shift" sortable></Column> */}
                </DataTable>
              </div>
              {/* <form onSubmit={formik.handleSubmit}> */}
              {/* <div className="col-12">
                <Button
                  className="pt-2 p-button-rounded"
                  label="Add"
                  onClick={assignUser}
                />
              </div> */}
              {/* </form> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};